<template>
  <div class="medai-gallery-audio-item">
    <audio-player v-if="options" :music="options"></audio-player>
  </div>
</template>

<script>

import AudioPlayer from 'vue-aplayer';
// import 'vue-dplayer/dist/vue-dplayer.css';

export default {
  name: 'MediaGalleryAudioItem',
  components: {
    AudioPlayer,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      options: null,
    };
  },
  mounted() {
    this.options = {
      title: ' ',
      artist: ' ',
      src: this.item.audio.url,
      pic: this.item.poster && this.item.poster.url,
    };
  },
};

</script>



// WEBPACK FOOTER //
// src/components/MediaGalleryAudioItem.vue